import { useSession } from 'next-auth/react';

import { useGrsSession } from '@/providers/GrsSessionProvider';
import { usePartnerConfig } from '@/providers/TenantProvider';

export const useAuth = () => {
  const config = usePartnerConfig();
  const { data, status } = useSession();
  const grsSession = useGrsSession();

  if (config.auth.strategy === 'session-storage') {
    return {
      accessToken: grsSession.accessToken,
      email: (grsSession.user?.email as string) ?? '',
      userId: (grsSession.user?.user_id as string) ?? '',
      status: grsSession.isAuthenticated
        ? ('authenticated' as const)
        : ('unauthenticated' as const),
      name: (grsSession.user?.name as string) ?? '',
    };
  }

  const accessToken = data?.accessToken ?? '';
  const email: string = data?.user?.email ?? '';
  const userId: string = data?.user?.user_id ?? '';
  const name: string = data?.user?.name ?? '';
  return { accessToken, email, userId, status, name };
};
